module.exports = __webpack_public_path__ + "media/images/board-eric-898390d0.png";